module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10211.b2ef297c.jpg";